(() => {
  const money = (cents, currency = 'USD') => new Intl.NumberFormat('en-US', {
    style: 'currency', currency, minimumFractionDigits: 2
  }).format((Number(cents) || 0) / 100);

  document.querySelectorAll('[data-countdown]').forEach((clock) => {
    let remaining = Math.max(1, Number(clock.dataset.minutes) || 15) * 60;
    const tick = () => {
      const minutes = Math.floor(remaining / 60);
      const seconds = String(remaining % 60).padStart(2, '0');
      clock.textContent = `${minutes}:${seconds}`;
      remaining = remaining > 0 ? remaining - 1 : Math.max(1, Number(clock.dataset.minutes) || 15) * 60;
    };
    tick();
    window.setInterval(tick, 1000);
  });

  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const slides = [...root.querySelectorAll('[data-gallery-slide]')];
    const thumbs = [...root.querySelectorAll('[data-gallery-thumb]')];
    const counter = root.querySelector('[data-gallery-counter]');
    const form = root.querySelector('[data-product-form]');
    const variantInput = root.querySelector('[data-variant-id]');
    const quantityInput = root.querySelector('[data-quantity]');
    const priceNode = root.querySelector('[data-price]');
    const compareNode = root.querySelector('[data-compare-price]');
    const savingsNode = root.querySelector('[data-savings]');
    const summaryNode = root.querySelector('[data-order-summary]');
    const bundleProperty = root.querySelector('[data-bundle-property]');
    const protectionProperty = root.querySelector('[data-protection-property]');
    const warrantyProperty = root.querySelector('[data-warranty-property]');
    const mainButton = root.querySelector('[data-main-atc]');
    const buttonLabel = root.querySelector('[data-atc-label]');
    const statusNode = root.querySelector('[data-form-status]');
    const currency = root.dataset.currency || 'USD';
    let galleryIndex = 0;
    let currentVariant = null;

    let variants = [];
    try {
      variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
    } catch (error) {
      console.warn('Variant data could not be read.', error);
    }

    const showSlide = (nextIndex) => {
      if (!slides.length) return;
      galleryIndex = (nextIndex + slides.length) % slides.length;
      slides.forEach((slide, index) => slide.classList.toggle('is-active', index === galleryIndex));
      thumbs.forEach((thumb, index) => {
        thumb.classList.toggle('is-active', index === galleryIndex);
        thumb.setAttribute('aria-current', index === galleryIndex ? 'true' : 'false');
      });
      if (counter) counter.textContent = `${galleryIndex + 1} / ${slides.length}`;
      thumbs[galleryIndex]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    };

    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => showSlide(index)));
    root.querySelector('[data-gallery-prev]')?.addEventListener('click', () => showSlide(galleryIndex - 1));
    root.querySelector('[data-gallery-next]')?.addEventListener('click', () => showSlide(galleryIndex + 1));

    let pointerStart = 0;
    root.querySelector('.product-gallery__stage')?.addEventListener('pointerdown', (event) => { pointerStart = event.clientX; });
    root.querySelector('.product-gallery__stage')?.addEventListener('pointerup', (event) => {
      const distance = event.clientX - pointerStart;
      if (Math.abs(distance) > 45) showSlide(galleryIndex + (distance < 0 ? 1 : -1));
    });

    const selectedOptions = () => [...root.querySelectorAll('[data-option-position]')].map((group) => {
      return group.querySelector('input:checked')?.value || '';
    });

    const selectedBundle = () => {
      const input = root.querySelector('.bundle-card input:checked');
      return { quantity: Number(input?.value || 1), discount: Number(input?.dataset.discount || 0) };
    };

    const updateSummary = () => {
      if (!currentVariant) return;
      const bundle = selectedBundle();
      const total = Math.round(currentVariant.price * bundle.quantity * (1 - bundle.discount / 100));
      const label = `${bundle.quantity} rug${bundle.quantity > 1 ? 's' : ''} · ${money(total, currency)}${bundle.discount ? ` · save ${bundle.discount}%` : ''}`;
      if (summaryNode) summaryNode.textContent = label;
      document.querySelectorAll('[data-sticky-summary]').forEach((node) => { node.textContent = label; });
      if (quantityInput) quantityInput.value = String(bundle.quantity);
      if (bundleProperty) bundleProperty.value = `Buy ${bundle.quantity}${bundle.discount ? ` · ${bundle.discount}% offer` : ''}`;
    };

    const updateVariant = () => {
      const options = selectedOptions();
      currentVariant = variants.find((variant) => variant.options.every((value, index) => value === options[index])) || variants[0] || null;
      if (!currentVariant) return;
      if (variantInput) variantInput.value = currentVariant.id;
      if (priceNode) priceNode.textContent = money(currentVariant.price, currency);
      const compare = Number(currentVariant.compare_at_price || 0);
      if (compareNode) {
        compareNode.textContent = compare > currentVariant.price ? money(compare, currency) : '';
        compareNode.hidden = compare <= currentVariant.price;
      }
      const saving = compare > currentVariant.price ? Math.round((1 - currentVariant.price / compare) * 100) : 0;
      if (savingsNode) {
        savingsNode.textContent = saving ? `Save ${saving}%` : 'Limited drop';
      }
      if (mainButton) mainButton.disabled = !currentVariant.available;
      if (buttonLabel) buttonLabel.textContent = currentVariant.available ? 'ADD TO CART' : 'SOLD OUT';
      history.replaceState({}, '', `${location.pathname}?variant=${currentVariant.id}${location.hash}`);
      updateSummary();
    };

    root.querySelectorAll('[data-option-position]').forEach((group, groupIndex) => {
      group.querySelectorAll('input').forEach((input) => input.addEventListener('change', () => {
        group.querySelector('[data-option-value]').textContent = input.value;
        if (groupIndex === 0) {
          const optionIndex = [...group.querySelectorAll('input')].indexOf(input);
          if (optionIndex >= 0 && optionIndex < slides.length) showSlide(optionIndex);
        }
        updateVariant();
      }));
    });

    root.querySelectorAll('.bundle-card input').forEach((input) => input.addEventListener('change', () => {
      root.querySelectorAll('.bundle-card').forEach((card) => card.classList.toggle('is-selected', card.contains(input)));
      updateSummary();
    }));

    root.querySelectorAll('[data-addon]').forEach((input) => input.addEventListener('change', () => {
      const yesNo = input.checked ? 'Yes' : 'No';
      if (input.dataset.addon === 'protection' && protectionProperty) protectionProperty.value = yesNo;
      if (input.dataset.addon === 'warranty' && warrantyProperty) warrantyProperty.value = yesNo;
    }));

    form?.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!currentVariant?.available || mainButton?.disabled) return;
      const bundle = selectedBundle();
      const protection = root.querySelector('[data-addon="protection"]')?.checked;
      const warranty = root.querySelector('[data-addon="warranty"]')?.checked;
      const properties = {
        Bundle: bundle.discount ? `Buy ${bundle.quantity} · ${bundle.discount}% offer` : `Buy ${bundle.quantity}`,
        'Package protection': protection ? 'Yes' : 'No',
        '30-day worry-free coverage': warranty ? 'Yes' : 'No'
      };
      const items = [{ id: currentVariant.id, quantity: bundle.quantity, properties }];
      if (protection && root.dataset.protectionId) items.push({ id: Number(root.dataset.protectionId), quantity: 1 });
      if (warranty && root.dataset.warrantyId) items.push({ id: Number(root.dataset.warrantyId), quantity: 1 });

      mainButton.disabled = true;
      if (buttonLabel) buttonLabel.textContent = 'ADDING…';
      if (statusNode) { statusNode.textContent = ''; statusNode.classList.remove('is-error'); }
      try {
        if (root.dataset.preview === 'true') {
          await new Promise((resolve) => window.setTimeout(resolve, 350));
          if (statusNode) statusNode.textContent = 'Preview successful — selection is ready for cart.';
          return;
        }
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'Unable to add this selection.');
        window.location.href = `${window.Shopify?.routes?.root || '/'}cart`;
      } catch (error) {
        if (statusNode) { statusNode.textContent = error.message; statusNode.classList.add('is-error'); }
      } finally {
        mainButton.disabled = !currentVariant.available;
        if (buttonLabel) buttonLabel.textContent = currentVariant.available ? 'ADD TO CART' : 'SOLD OUT';
      }
    });

    updateVariant();
    showSlide(0);

    const sticky = document.querySelector('[data-sticky-atc]');
    const stickyButton = sticky?.querySelector('[data-sticky-atc-button]');
    stickyButton?.addEventListener('click', () => mainButton?.click());
    if (mainButton && sticky && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(([entry]) => {
        const visible = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.hidden = !visible;
        document.body.classList.toggle('has-sticky-atc', visible);
      }, { threshold: 0 });
      observer.observe(mainButton);
    }
  });

  document.querySelectorAll('[data-testimonial-section]').forEach((section) => {
    const track = section.querySelector('[data-testimonial-track]');
    const cards = [...section.querySelectorAll('[data-testimonial-card]')];
    const dots = section.querySelector('[data-testimonial-dots]');
    let index = 0;
    if (!track || cards.length < 2) return;
    cards.forEach((_, cardIndex) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.setAttribute('aria-label', `Show review ${cardIndex + 1}`);
      dot.addEventListener('click', () => move(cardIndex));
      dots?.appendChild(dot);
    });
    const move = (next) => {
      index = (next + cards.length) % cards.length;
      if (matchMedia('(max-width: 767px)').matches) {
        const gap = 15;
        track.style.transform = `translateX(calc(${-index * 100}% - ${index * gap}px))`;
      } else {
        track.style.transform = '';
        index = 0;
      }
      [...(dots?.children || [])].forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === index));
    };
    section.querySelector('[data-testimonial-prev]')?.addEventListener('click', () => move(index - 1));
    section.querySelector('[data-testimonial-next]')?.addEventListener('click', () => move(index + 1));
    window.addEventListener('resize', () => move(index));
    move(0);
  });
})();

